"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _polished = require("polished");

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var visibleStyles = (0, _styledComponents.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  visibility: visible;\n  opacity: 1;\n"])));

var StyledWrapper = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: fixed;\n  z-index: 1001;\n  top: ", ";\n  left: 0;\n  width: 100%;\n  visibility: hidden;\n  opacity: 0;\n  padding: 0 0.5rem;\n\n  ", ";\n\n  transition-property: visibility, opacity;\n  transition-duration: 0.7s;\n\n  @media (min-width: ", ") {\n    left: 50%;\n    width: ", ";\n    transform: translateX(-50%);\n  }\n"])), function (p) {
  return p.isLeaderboardBarVisible ? "10.25rem" : "7.25rem";
}, function (p) {
  return p.isVisible && visibleStyles;
}, function (props) {
  return props.theme.screenWidthMd;
}, function (props) {
  return props.theme.railWidth;
});

var appear = (0, _styledComponents.keyframes)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  0% { transform: translateY(1.5rem);}\n  100% { transform: translateY(0);}\n"])));

var StyledCard = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 300px;\n  padding: 1rem 1rem 1.5rem;\n  line-height: 1.25;\n  border-radius: ", ";\n  box-shadow: 0 0 20px ", ";\n  background: ", ";\n  animation: ", " 0.7s;\n"])), function (p) {
  return p.theme.borderRadius;
}, (0, _polished.rgba)("black", 0.12), function (p) {
  return p.theme.colorCardBackground;
}, function (p) {
  return p.isVisible ? appear : null;
});

var StyledTitle = _styledComponents.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  margin-bottom: 0.5rem;\n  ", "\n"])), function (p) {
  return p.theme.colorText;
});

var StyledBadge = _styledComponents.default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  padding: 0.25rem;\n  background: ", ";\n  color: white;\n  border-radius: 0.25rem;\n  font-size: 0.635rem;\n  margin-left: 0.5rem;\n"])), function (p) {
  return p.theme.colorAlertSuccessText;
});

var StyledText = _styledComponents.default.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.15rem;\n  margin-bottom: 1rem;\n  color: ", ";\n"])), function (p) {
  return p.theme.colorLabel;
});

var Wrapper = function Wrapper(_ref) {
  var app = _ref.app,
      setApp = _ref.setApp,
      isLeaderboard = _ref.isLeaderboard;
  var dispatch = (0, _reactRedux.useDispatch)();
  var hasReadBetbarHelp = app.hasReadBetbarHelp,
      isDevEnvironment = app.isDevEnvironment;

  var _useSelector = (0, _reactRedux.useSelector)(function (s) {
    return s.betbar;
  }),
      activePickemList = _useSelector.activePickemList,
      isActivePickemApproved = _useSelector.isActivePickemApproved;

  var handleHelpDismissed = function handleHelpDismissed() {
    if (!isDevEnvironment) {
      localStorage.setItem("fiver_has_read_betbar_help", "true");
    }

    setApp({
      hasReadBetbarHelp: true
    });
  };

  var isVisible = !hasReadBetbarHelp;
  console.log("betbar help is visible", isVisible);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledWrapper, {
    isVisible: isVisible,
    isLeaderboardBarVisible: !isActivePickemApproved && isLeaderboard,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledCard, {
      isVisible: isVisible,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledTitle, {
        children: ["Low6 Bet Bar", /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledBadge, {
          children: "New"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledText, {
        children: "This feature allows you to make picks in multiple matches and contests!"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.BlockButton, {
        onClick: handleHelpDismissed,
        size: "xs",
        children: "Ok, got it!"
      })]
    })
  });
};

var _default = Wrapper;
exports.default = _default;